// OWNER: care module. Route objects relative to /w/:wsId, spread into the router by src/app/router.tsx.
// Pages are lazy-loaded so each feature is its own chunk. Add routes here; don't edit the router.
import type { RouteObject } from 'react-router';

const pages = () => import('./pages');

export const routes: RouteObject[] = [
  { path: 'money/care', lazy: async () => ({ Component: (await pages()).CarePage }) },
  { path: 'money/care/contracts', lazy: async () => ({ Component: (await pages()).CareContractsPage }) },
  { path: 'money/care/contracts/:contractId', lazy: async () => ({ Component: (await pages()).CareContractDetailPage }) },
];
